




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ADDPOSTJOB= createAsyncThunk(
  "addpostjob/addpostjob",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addpostjobSlice = createSlice({
  name: "addpostjobSlice",
  initialState: {
    addpostjob: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddpostjob: (state) => {
        state.addpostjob.loading = false
        state.addpostjob.error = false
        state.addpostjob.data = []
        state.addpostjob.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDPOSTJOB.fulfilled, (state, action) => {
      state.addpostjob = {
        ...state.addpostjob,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTJOB.pending, (state, action) => {
      state.addpostjob = {
        ...state.addpostjob,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPOSTJOB.rejected, (state, action) => {
      state.addpostjob = {
        ...state.addpostjob,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addpostjobAction = {
    ADDPOSTJOB,
};

export { addpostjobAction };
export default addpostjobSlice.reducer;
export const {setInitialStateOfaddpostjob} = addpostjobSlice.actions
